import { useState, useEffect, useMemo } from "react";
import { v4 } from "uuid";
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import SearchIcon from '@mui/icons-material/Search';
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import { withStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import {
  ErrorRounded,
  AutoStoriesRounded,
  BeenhereRounded
} from "@mui/icons-material";
import DraftsRoundedIcon from '@mui/icons-material/DraftsRounded';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import { fetchOfficersList } from "slices/officers";
import TopBar from "_shared/Top";
import { Button, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import exportExcel from "utils/excelGenerate";
import { getAllProspects, getListofSE } from "_controllers/officer";
import { toastMessage } from "utils/toastMessage";
import ServiceEngineer from "./ServiceEngineer";


const Main = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { user } = useSelector((state) => state.user);
  const { officers } = useSelector((state) => state.officers);
  const [pageSize, setPageSize] = useState(10)
  console.log({ OFF: officers })

  const [data, setData] = useState([]);
  const [search, setSearch] = useState('')
  const [role, setRole] = useState('');
  const [userId, setUserId] = useState('')
  const [zmList, setZMList] = useState('')

  const [solist, setSOList] = useState(true)

  const [seList, setSeList] = useState([])

  const fileName = `PJP-Monthly-Details-${user.SAP_ID}`

  useEffect(async () => {
    if (!user?._id) return;

    dispatch(fetchOfficersList(user.SAP_ID));
  }, [user, solist]);
  // console.log("object", user);
  useEffect(() => {
    console.log("df", officers)
    const _rData = officers
      // .filter((officer) => officer.role === "SO")
      .map((user) => ({
        id: v4(),
        SAP_ID: user.SAP_ID,
        // name: user?.name ? user?.name : null,
        // territories:
        //   user.territories
        //     ?.map((t) => `${t.name}`),
        // .join(", ") || "",
        // phone: user.phone || "-",
        zone: user.zone ? user.zone : "-",
        region: user.regionName ? user.regionName : "-",
        area: user.areaName ? user.areaName : "-",
        territory: user.territoryName ? user.territoryName : "-",
        review: user.stats.inReview || 0,
        draft: user.stats?.draft || 0,
        approved: user.stats?.approved || 0,
        reverted: user.stats?.reverted || 0,
      }));

    setData(_rData);
  }, [officers, solist]);

  useEffect(() => {
    const _rData = officers
      .filter((officer) => officer?.SAP_ID?.toUpperCase().includes(search?.toUpperCase()) ||
        // officer?.territories[0]?.name.toUpperCase().includes(search.toUpperCase()) ||
        officer?.zone?.toUpperCase().includes(search.toUpperCase()) ||
        officer?.regionName?.toUpperCase().includes(search.toUpperCase()) ||
        officer?.areaName?.toUpperCase().includes(search.toUpperCase())
      )
      .map((user) => ({
        id: v4(),
        SAP_ID: user.SAP_ID,
        // territories:
        //   user.territories
        //     ?.map((t) => `${t.territoryCode} (${t.name})`)
        //     .join(", ") || "",
        // territories: user?.territories,
        // territories:
        //   user.territories
        //     ?.map((t) => `${t.name}`),
        zone: user?.zone ? user.zone : "-",
        region: user?.regionName ? user.regionName : "-",
        area: user?.areaName ? user.areaName : "-",
        review: user?.stats.inReview || 0,
        draft: user?.stats?.draft || 0,
        approved: user?.stats?.approved || 0,
        reverted: user?.stats?.reverted || 0,
      }));

    setData(_rData);
  }, [search])



  console.log("SEARCH", search);

  const columns = useMemo(() => [
    // {
    //   field: "id",
    //   headerName: "ID",
    // },
    {
      field: "SAP_ID",
      headerName: "SAP ID",
      // width: 150,
      flex: 1
    },
    // {
    //   field: "name",
    //   headerName: "Name",
    //   width: 200,
    // },
    {
      field: "zone",
      headerName: "Zone",
      // width: 150,
      flex: 1
    },
    {
      field: "region",
      headerName: "Region",
      // width: 175,
      flex: 1
    },
    {
      field: "area",
      headerName: "Area",
      // width: 175,
      flex: 1
    },
    // {
    //   field: "phone",
    //   headerName: "Phone",
    //   width: 150,
    // },
    {
      field: "review",
      headerName: "In-Review",
      // width: 100,
      flex: 1
      // renderHeader: () => <AutoStoriesRounded sx={{ color: "#333" }} />,
    },
    {
      field: "draft",
      headerName: "Draft",
      // width: 100,
      flex: 1
      // renderHeader: () => <DraftsRoundedIcon sx={{ color: "#333" }} />,
    },
    {
      field: "approved",
      headerName: "Approved",
      // width: 100,
      flex: 1
      // renderHeader: () => <BeenhereRounded sx={{ color: "#333" }} />,
    },
    {
      field: "reverted",
      headerName: "Reverted",
      // width: 100,
      flex: 1
      // renderHeader: () => <ErrorRounded sx={{ color: "#333" }} />,
    },
  ]);

  // const rows = [
  //   {
  //     id: 0,
  //     name: "Test",
  //     SAP_ID: "Test",
  //     territories: "1, 2,3",
  //     email: "test@gmail.com",
  //     review: 5,
  //     accepted: 10,
  //   },
  //   {
  //     id: 1,
  //     name: "Test",
  //     SAP_ID: "Test",
  //     territories: "1, 2,3",
  //     email: "test@gmail.com",
  //     review: 5,
  //     accepted: 10,
  //   },
  // ];
  const ROList = [{
    "regionCode": "1182",
    "regionName": "GUWAHATI",
    "role": "RO",
    "SAP_ID": "ROGHW"
  }, {
    "regionCode": "1681",
    "regionName": "Patna",
    "role": "RO",
    "SAP_ID": "ROPATNA"
  }, {
    "regionCode": "3181",
    "regionName": "DELHI",
    "role": "RO",
    "SAP_ID": "RODLH"
  }, {
    "regionCode": "3281",
    "regionName": "FARIDABAD",
    "role": "RO",
    "SAP_ID": "ROFBD"
  }, {
    "regionCode": "3381",
    "regionName": "JALLANDHAR",
    "role": "RO",
    "SAP_ID": "ROJAL"
  }, {
    "regionCode": "3681",
    "regionName": "JAIPUR",
    "role": "RO",
    "SAP_ID": "ROJPR"
  }, {
    "regionCode": "3682",
    "regionName": "JODHPUR",
    "role": "RO",
    "SAP_ID": "ROJDP"
  }, {
    "regionCode": "3781",
    "regionName": "KANPUR",
    "role": "RO",
    "SAP_ID": "ROKNP"
  }, {
    "regionCode": "3782",
    "regionName": "MEERUT",
    "role": "RO",
    "SAP_ID": "ROMRT"
  }, {
    "regionCode": "5181",
    "regionName": "H.BAD",
    "role": "RO",
    "SAP_ID": "ROHYD"
  }, {
    "regionCode": "5182",
    "regionName": "VIJAYWADA",
    "role": "RO",
    "SAP_ID": "ROVJW"
  }, {
    "regionCode": "5281",
    "regionName": "BNGLR",
    "role": "RO",
    "SAP_ID": "ROBNG"
  }, {
    "regionCode": "5381",
    "regionName": "CHENNAI",
    "role": "RO",
    "SAP_ID": "ROCHN"
  }, {
    "regionCode": "5382",
    "regionName": "Cochin",
    "role": "RO",
    "SAP_ID": "ROCOCHIN"
  }, {
    "regionCode": "7181",
    "regionName": "INDORE",
    "role": "RO",
    "SAP_ID": "ROIND"
  }, {
    "regionCode": "1683",
    "regionName": "RANCHI",
    "role": "RO",
    "SAP_ID": "RORANCHI"
  }, {
    "regionCode": "7381",
    "regionName": "MUMBAI",
    "role": "RO",
    "SAP_ID": "ROMUM"
  }, {
    "regionCode": "7382",
    "regionName": "NAGPUR",
    "role": "RO",
    "SAP_ID": "RONGP"
  }, {
    "regionCode": "7581",
    "regionName": "AHMEDABAD",
    "role": "RO",
    "SAP_ID": "ROAHM"
  }, {
    "regionCode": "1181",
    "regionName": "KOLKATTA",
    "role": "RO",
    "SAP_ID": "ROCAL"
  }, {
    "regionCode": "7182",
    "regionName": "RAIPUR",
    "role": "RO",
    "SAP_ID": "RORAIPUR"
  }, {
    "regionCode": "7183",
    "regionName": "JABALPUR",
    "role": "RO",
    "SAP_ID": "ROJBL"
  }, {
    "regionCode": "7184",
    "regionName": "CUTTAK",
    "role": "RO",
    "SAP_ID": "ROCUTTACK"
  }, {
    "regionCode": "7582",
    "regionName": "RAJKOT",
    "role": "RO",
    "SAP_ID": "ROAHM"
  }, {
    "regionCode": "3382",
    "regionName": "CHANDIGARH",
    "role": "RO",
    "SAP_ID": "ROCHD"
  }, {
    "regionCode": "5282",
    "regionName": "HUBLI",
    "role": "RO",
    "SAP_ID": "ROBNG"
  }, {
    "regionCode": "3783",
    "regionName": "VARANASI",
    "role": "RO",
    "SAP_ID": "ROKNP"
  }, {
    "regionCode": "5383",
    "regionName": "Coimbatore",
    "role": "RO",
    "SAP_ID": "ROCOCHIN"
  }]

  const handleRole = (e) => {
    setRole(e.target.value)
  }
  const handleChange = (e) => {
    setSearch(e.target.value);
  };
  const handleUserId = (e) => {
    setUserId(e.target.value)
  }

  console.log("first", role, userId)
  const generateExcel = async (e) => {
    e.preventDefault()
    exportExcel(data.map(x => ({
      'SAP ID': x?.SAP_ID,
      "Zone": x?.zone,
      "Region": x?.region,
      "Area": x?.area,
      'Approved': x?.approved,
      'Review': x?.review,
      'Reverted': x?.reverted,
      'Draft': x?.draft,
    })), fileName)
  }

  return (
    <div style={{ width: "98%", marginTop: "2.5rem", marginBottom: "2rem" }}>
      <div style={{ paddingBottom: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center ' }}>
        <TextField
          onChange={handleChange}
          value={search}
          name="search"
          variant="outlined"
          label="SAP ID or Territory"
          // fullWidth
          sx={{ width: '93%' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <DownloadIcon sx={{ border: '1px solid darkgrey', fontSize: '55px', borderRadius: '3px', cursor: 'pointer' }} onClick={generateExcel} />
      </div>
      {/* <div style={{ paddingBottom: '1rem' }}>
        {
          user?.role === "ADMIN" ?
            <div style={{ paddingBottom: '1rem', paddingTop: '0.5rem' }}>
              <Grid container spacing={5}>
                <Grid item xs={5}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Role</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={role}
                      label="Role"
                      onChange={handleRole}
                    >
                      <MenuItem value={"ZM"}>Zonal Manager</MenuItem>
                      <MenuItem value={"RM"}>Regional Manager</MenuItem>
                      <MenuItem value={"AM"}>Area Manager</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={5}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Users</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={userId}
                      label="Users"
                      onChange={handleUserId}
                    >
                      {ROList &&
                        ROList.map((x) => {
                          return (
                            <MenuItem value={x?.SAP_ID} key={x?.SAP_ID}>
                              {x?.SAP_ID} - {x?.regionName}
                            </MenuItem>
                          );
                        })}
                      {/* <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem> */}
      {/* </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2} style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                  <SearchIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} />
                  {/* <DownloadIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} /> */}
      {/* </Grid>
              </Grid>
            </div>
            : null
        }
      </div> */}
      {/* <div><Button onClick={() => setSOList(true)} variant={`${solist ? "contained" : "outlined"}`}>
        All Users
      </Button>
        <Button onClick={() => setSOList(false)} style={{ marginLeft: "2rem", width: "120px" }} variant={`${solist ? "outlined" : "contained"}`}>SE</Button>
      </div> */}

      {
        solist ? (<DataGrid
          rows={data}
          columns={columns}
          autoHeight={true}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onRowClick={(data) => history.push(`/SO/${data.row.SAP_ID}/PJP`)}
          className="TableCell"
          rowsPerPageOptions={[10, 25, 50, 100]}
          sx={{ fontSize: "0.75rem" }}
        />) : (<ServiceEngineer />)
      }


    </div >
  );
};

const Home = () => {
  const { loading, user } = useSelector((state) => state.user);
  console.log({ TU: user }) // logged AO details.

  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
    </AccessController>
  );
};

export default Home;
